export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(registration => {
        // Verificar atualizações a cada 1 hora
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);

        // Quando houver uma nova versão
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Notificar o usuário sobre a atualização
                if (confirm('Uma nova versão está disponível. Deseja atualizar agora?')) {
                  // Enviar mensagem para o SW ativar a nova versão
                  newWorker.postMessage('skipWaiting');
                  // Recarregar a página
                  window.location.reload();
                }
              }
            });
          }
        });
      }).catch(error => {
        console.error('Erro ao registrar service worker:', error);
      });

      // Lidar com a ativação de um novo service worker
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    });
  }
} 